import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from '../DiscountOffer.module.css';
import { Typography } from '../../../components/Typography/typography';

const ResultsSection = () => {
    const { t } = useTranslation();
    
    return (
        <div className={styles.realResultsSection}>
            <div className={styles.realResultsContent}>
                <Typography
                    title={t('discount_offer.results_title')}
                    fontSize={42}
                    weight="600"
                    color="#181818"
                />
                <Typography
                    title={t('discount_offer.results_description')}
                    fontSize={16}
                    weight="400"
                    color="#181818"
                 />
            </div>
            <div className={styles.candidateImagesContainer}>
                <img 
                    src={require('../../../assets/images/discountOffer/discount_offer_job_seeker.png')} 
                    className={styles.candidateImage1}
                    alt="Job seeker"
                />
                <img 
                    src={require('../../../assets/images/discountOffer/discount_offer_employer.png')} 
                    className={styles.candidateImage2}
                    alt="Employer"
                />
            </div>
        </div>
    );
};

export default ResultsSection; 